import { leadConstants } from '../constants';

export const leadReducer = (state = {}, action) => {
    switch(action.type) {
        case leadConstants.GET_ALL_LEADS_REQUEST:
            return {
                ...state,
                getAllLeadsProcess: true
            }

        case leadConstants.GET_ALL_LEADS_SUCCESS: 
            return {
                ...state,
                list: action.payload,
                getAllLeadsProcess: false,
                getAllLeadsError: false
            }

        case leadConstants.GET_ALL_LEADS_FAILURE:
            return {
                ...state,
                getAllLeadsProcess: false,
                getAllLeadsError: true
            }

        case leadConstants.DELETE_LEAD_REQUEST: 
        {
            let {leadID} = action.payload;
            
            return {
                ...state,
                deleteLeadProcessList: {...state.deleteLeadProcessList, [leadID]: true}
            }
        }

        case leadConstants.DELETE_LEAD_SUCCESS: 
        {
            let {leadID} = action.payload;
            let allLeads = state.list || [];
            let updatedLeadList = allLeads.filter((item) => {
                return item._id !== leadID;
            });

            return {
                ...state,
                list: updatedLeadList,
                deleteLeadProcessList: {...state.deleteLeadProcessList, [leadID]: false},
                deleteLeadErrorList: {...state.deleteLeadErrorList, [leadID]: false}
            }
        }

        case leadConstants.DELETE_LEAD_FAILURE: 
        {
            let {leadID} = action.payload;
            
            return {
                ...state,
                deleteLeadProcessList: {...state.deleteLeadProcessList, [leadID]: false},
                deleteLeadErrorList: {...state.deleteLeadErrorList, [leadID]: true}
            }
        }

        case leadConstants.UPDATE_LEAD_REQUEST: 
        {
            let {leadID} = action.payload;

            return {
                ...state,
                updateLeadProcessList: {...state.updateLeadProcessList, [leadID]: true},
            }
        }

        case leadConstants.UPDATE_LEAD_SUCCESS: 
        {
            let {_id} = action.payload;
            let allLeads = state.list || [];
            let updatedLeadList = allLeads.map((item) => {
                if(item._id === _id) return action.payload;
                return item;
            });

            return {
                ...state,
                list: updatedLeadList,
                updateLeadProcessList: {...state.updateLeadProcessList, [_id]: false},
                updateLeadErrorList: {...state.updateLeadErrorList, [_id]: false}
            }
        }

        case leadConstants.UPDATE_LEAD_FAILURE: 
        {
            let {leadID} = action.payload;

            return {
                ...state,
                updateLeadErrorList: {...state.updateLeadErrorList, [leadID]: true}
            }
        }

        default: 
            return state;
    }
}

export default leadReducer;


// WEBPACK FOOTER //
// ./src/reducers/lead.js